import axios from "axios";
import { QuestionaryType } from "../models/QuestionaryType";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getQuestionaryTypes = async (): Promise<QuestionaryType[]> => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryType/GetAll`);
  const data = await response.json();
  return data;
};

const insert = async (questionaryType: QuestionaryType)=> {
    const response = await fetch(`${API_BASE_URL}/QuestionaryType/Insert`, {
        method: "POST",
         headers: { "Content-Type": "application/json; charset= utf-8" },
         body: JSON.stringify(questionaryType),
    })
    return response
};

const update = async (questionaryType: QuestionaryType) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryType/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(questionaryType),
  });

  return response;
};

const remove = async (questionaryType: QuestionaryType) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryType/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(questionaryType),
  });

  return response;
};

interface CloneQuestionaryTypeRequest {
  questionaryTypeIdToClone: number;
  newQuestionaryName: string;
}

const clone = async (request: CloneQuestionaryTypeRequest): Promise<string> => {
  try {
    const response = await axios.post<string>(
      `${API_BASE_URL}/QuestionaryType/Clone`,
      request
    );
    return response.data;
  } catch (error) {
    console.error("Error cloning questionary type:", error);
    throw error;
  }
};

const archive = async (questionaryType: QuestionaryType) => {
    const response = await fetch(`${API_BASE_URL}/QuestionaryType/Archive`, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset= utf-8" },
        body: JSON.stringify(questionaryType),
  });

  return response;
}

const QuestionaryTypeService = {
  getQuestionaryTypes,
  insert,
  update,
  remove,
  clone,
  archive
};

export default QuestionaryTypeService;
